import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

function initSentry(app: App, router: Router) {
   const browserTracing = Sentry.browserTracingIntegration({ router });
   const enabled = ['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV);

   Sentry.init({
      app,
      attachProps: true,
      attachStacktrace: true,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      enabled,
      environment: import.meta.env.VITE_APP_ENV,
      ignoreErrors: [
         'Request aborted',
         'AxiosError',
         'Network Error',
         // Ignore dynamic import failures - these happen when users have cached old HTML after new deployments
         /Failed to fetch dynamically imported module/i,
         /error loading dynamically imported module/i,
         /dynamically imported module/i,
      ],
      integrations: [browserTracing],
      logErrors: true,
      maxBreadcrumbs: 50,
      release: import.meta.env.VITE_APP_VERSION,
      tracesSampleRate: 0.1,
      trackComponents: true,
   });
}

export { initSentry };
